<form [formGroup]="form" (ngSubmit)="onSubmit()">

  <div class="erma-zadosti-toolbar">
    <app-print-button (buttonClicked)="onSubmit()" (cleared)="onClear()" (closed)="onClose()" [blocked]="blocked" [dialogVisible]="dialogVisible"></app-print-button>
    <app-isds-button (buttonClicked)="onSubmit(true)" [block]="isdsBlocked" *ngIf="isdsBtnVisible"></app-isds-button>
  </div>

  <app-messages [key]="MSG_KEY"></app-messages>

  <div class="erma-zadosti-form">
    <div>

      <h1>Oznámení o konání sběru semenného materiálu, odběru částí rostlin nebo vyzvedávání sadebního materiálu z přirozeného zmlazení, nebo o konání odběru částí rostlin, jde-li o následně vegetativně množený reprodukční materiál, anebo o sloučení oddílů reprodukčního materiálu</h1>

      <div class="erma-zadosti-head">
        <label for="cislo">Číslo:</label>
        <input type="number" id="cislo" formControlName="cislo" />
        <label for="rok">rok:</label>
        <input type="number" id="rok" formControlName="rok" />
        <label for="pobocka">Pobočka pověřené osoby:</label>
        <app-ciselnik-dropdown inputId="pobocka" formControlName="pobockaPovereneOsoby" [ciselnikData]="pobockaList" [headerStyle]="true" class="select"></app-ciselnik-dropdown>
      </div>

      <div formGroupName="dodavatel">

        <div class="p-grid">
          <div class="p-col-12 sekce">1) Označení dodavatele:</div>
        </div>

        <div class="p-grid">
          <div class="p-col-2">u fyzických osob:</div>
        </div>

        <div class="p-grid">
          <div class="p-col-1 p-offset-1"><label for="jmeno">jméno:</label></div>
          <div class="p-col-2"><span class="input-like">{{form.value.dodavatel.jmeno}}&nbsp;</span></div>
          <div class="p-col-1"><label for="prijmeni">příjmení:</label></div>
          <div class="p-col-3"><span class="input-like">{{form.value.dodavatel.prijmeni}}&nbsp;</span></div>
          <div class="p-col-2"><label for="dat-naroz">datum narození:</label></div>
          <div class="p-col-2">
            <span class="input-like" *ngIf="!form.value.dodavatel.prijmeni">&nbsp;</span>
            <input type="date" id="dat-naroz" formControlName="datNaroz" *ngIf="form.value.dodavatel.prijmeni" />
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-3 p-offset-1"><label for="obch-nazev-fo">obchodní firma nebo název:</label></div>
          <div class="p-col-8"><span class="input-like">{{form.value.dodavatel.prijmeni ? form.value.dodavatel.obchNaz : ''}}&nbsp;</span></div>
        </div>

        <div class="p-grid">
          <div class="p-col-3 p-offset-1"><label for="adr-trvaleho-pobytu">adresa místa trvalého pobytu:</label></div>
          <div class="p-col-8">
            <span class="input-like" *ngIf="!form.value.dodavatel.prijmeni">&nbsp;</span>
            <input type="text" id="adr-trvaleho-pobytu" formControlName="adresaTrvalehoPobytuFo" *ngIf="form.value.dodavatel.prijmeni" />
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-3 p-offset-1"><label for="adr-podnikani-fo">adresa místa podnikání, liší-li se od adresy trvalého pobytu:</label></div>
          <div class="p-col-8">
            <span class="input-like" *ngIf="!form.value.dodavatel.prijmeni">&nbsp;</span>
            <input type="text" id="adr-podnikani-fo" formControlName="adresaPodnikaniFo" *ngIf="form.value.dodavatel.prijmeni" />
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-2">u právnických osob:</div>
        </div>

        <div class="p-grid">
          <div class="p-col-3 p-offset-1"><label for="obch-nazev-po">obchodní firma nebo název:</label></div>
          <div class="p-col-8"><span class="input-like">{{form.value.dodavatel.prijmeni ? '' : form.value.dodavatel.obchNaz}}&nbsp;</span></div>
        </div>

        <div class="p-grid">
          <div class="p-col-3 p-offset-1"><label for="adr-sidla">adresa sídla:</label></div>
          <div class="p-col-8"><span class="input-like">{{form.value.dodavatel.adresaSidlaPo}}&nbsp;</span></div>
        </div>

        <div class="p-grid">
          <div class="p-col-4"><label for="ico"><span class="sekce">2) Identifikační číslo dodavatele</span>, bylo-li přiděleno:</label></div>
          <div class="p-col-4"><span class="input-like">{{form.value.dodavatel.ico}}&nbsp;</span></div>
        </div>

      </div>

      <div formGroupName="licence">

        <div class="p-grid">
          <div class="p-col-2"><label for="licence-cislo"><span class="sekce">3) Licence</span> č.j.</label></div>
          <div class="p-col-3"><span class="input-like">{{form.value.licence.cj}}&nbsp;</span></div>
          <div class="p-col-1"><label for="licence-ze-dne">ze dne</label></div>
          <div class="p-col-2"><span class="input-like">{{form.value.licence.zeDne | czechDate}}&nbsp;</span></div>
          <div class="p-col-2"><label for="licence-nabyla-pravni-moci">nabyla právní moci</label></div>
          <div class="p-col-2"><span class="input-like">{{form.value.licence.nabylaPravniMoci | czechDate}}&nbsp;</span></div>
        </div>

        <div class="p-grid">
          <div class="p-col-3"><label for="licence-cislo-jr">Číslo jednotného registru:</label></div>
          <div class="p-col-2"><app-prefixed-input id="licence-cislo-jr" formControlName="cisloJr"></app-prefixed-input></div>
        </div>

      </div>

      <div class="p-grid">
        <div class="p-col-3 sekce"><label for="misto-sberu">4) Místo sběru:</label></div>
        <div class="p-col-9">
          <input type="text" id="misto-sberu" formControlName="mistaSberu" />
          (označení jednotek prostorového rozdělení lesa nebo název katastrálního území a parcelní číslo)
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-4 sekce"><label for="oblastProvenience">5) Oblast provenience:</label></div>
        <div class="p-col-4">
          <span class="input-like">{{form.value.oblastProvenience ? form.value.oblastProvenience.kod + ' - ' + form.value.oblastProvenience.popis : ''}}&nbsp;</span>
        </div>
      </div>

      <div formGroupName="druhDreviny">

        <div class="p-grid">
          <div class="p-col-2 sekce">6) Druh dřeviny:</div>
          <div class="p-col-2"><label for="druhDreviny-cz-nazev">a) český název:</label></div>
          <div class="p-col-4"><span class="input-like">{{form.value.druhDreviny.nazevCesky}}&nbsp;</span></div>
        </div>

        <div class="p-grid">
          <div class="p-col-2 p-offset-2"><label for="druhDreviny-vedecky-nazev">b) vědecký název:</label></div>
          <div class="p-col-4"><span class="input-like">{{form.value.druhDreviny.nazevVedecky}}&nbsp;</span></div>
        </div>

        <div class="p-grid">
          <div class="p-col-2 p-offset-2"><label for="druhDreviny-oznaceni-klonu">c) označení klonu nebo směsi klonů:</label></div>
          <div class="p-col-8"><input type="text" id="druhDreviny-oznaceni-klonu" formControlName="oznaceniKlonu" /></div>
        </div>

      </div>

      <div class="p-grid">
        <div class="p-col-4 sekce"><label for="kategorie-rm">7) Reprodukční materiál kategorie:</label></div>
        <div class="p-col-4"><span class="input-like">{{form.value.repMaterialKategorie?.popis}}&nbsp;</span></div>
      </div>

      <div class="p-grid">
        <div class="p-col-4 sekce"><label for="druh-rm">8) Druh reprodukčního materiálu:</label></div>
        <div class="p-col-4">
          <app-ciselnik-dropdown inputId="druh-rm" formControlName="druhRepMaterialu" [ciselnikData]="druhRMList"></app-ciselnik-dropdown>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-4 sekce"><label for="typ-zdroje-rm">9) Typ zdroje reprodukčního materiálu:</label></div>
        <div class="p-col-4"><span class="input-like">{{form.value.typZdrojeRepMaterialu?.popis}}&nbsp;</span></div>
      </div>

      <div class="p-grid">
        <div class="p-col-4 sekce"><label for="cislo-uj">10) Evidenční číslo uznané jednotky:</label></div>
        <div class="p-col-4"><app-naseptavac-uj id="cislo-uj" formControlName="evCisloUj"></app-naseptavac-uj></div>
      </div>

      <div formGroupName="predpokladanySber">

        <div class="p-grid">
          <div class="p-col-4"><label for="datum-sberu-od"><span class="sekce">11) Přepodkládané datum sběru</span> od:</label></div>
          <div class="p-col-2"><input type="date" id="datum-sberu-od" formControlName="od" /></div>
          <div class="p-col-1"><label for="datum-sberu-do">do:</label></div>
          <div class="p-col-2"><input type="date" id="datum-sberu-do" formControlName="do" /></div>
        </div>

      </div>

      <div class="p-grid">
        <div class="p-col-4 sekce"><label for="max-mnozstvi">12) Plánované maximální množství:</label></div>
        <div class="p-col-2"><input type="number" id="max-mnozstvi" formControlName="maxMnozstvi" /></div>
        <div class="p-col-2" *ngIf="form.value.DruhRepMaterialu?.kod == semennyRm">kg</div>
        <div class="p-col-2" *ngIf="form.value.DruhRepMaterialu?.kod > semennyRm">ks</div>
      </div>

      <div formGroupName="vlastnikZdroje">
        <div class="p-grid">
          <div class="p-col-12 sekce">13) Vlastník zdroje reprodukčního materiálu:</div>
        </div>
        <div class="p-grid">
          <div class="p-col-4"><label for="vlastnik-jmeno">jméno</label></div>
          <div class="p-col-2">
            <input type="text" id="vlastnik-jmeno" formControlName="jmeno" *ngIf="souhlasVlastnika?.value && !vlastnik?.value?.obchNaz" />
            <span class="input-like" *ngIf="!souhlasVlastnika?.value || vlastnik?.value?.obchNaz">&nbsp;</span>
          </div>
          <div class="p-col-1"><label for="vlastnik-prijmeni">příjmení</label></div>
          <div class="p-col-5">
            <input type="text" id="vlastnik-prijmeni" formControlName="prijmeni" *ngIf="souhlasVlastnika?.value && !vlastnik?.value?.obchNaz" />
            <span class="input-like" *ngIf="!souhlasVlastnika?.value || vlastnik?.value?.obchNaz">&nbsp;</span>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-4"><label for="vlastnik-obch-nazev">obchodní firma nebo název</label></div>
          <div class="p-col-8">
            <input type="text" id="vlastnik-obch-nazev" formControlName="obchNaz" *ngIf="souhlasVlastnika?.value && !vlastnik?.value?.jmeno && !vlastnik?.value?.prijmeni" />
            <span class="input-like" *ngIf="!souhlasVlastnika?.value || vlastnik?.value?.jmeno || vlastnik?.value?.prijmeni">&nbsp;</span>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-4">
            <label for="vlastnik-adresa">
              adresa místa trvalého pobytu nebo adresa místa podnikání, liší-li se od adresy trvalého pobytu, nebo adresa sídla:
            </label>
          </div>
          <div class="p-col-8">
            <input type="text" id="vlastnik-adresa" formControlName="adresa" *ngIf="form.value.souhlasVlastnika" />
            <span class="input-like" *ngIf="!form.value.souhlasVlastnika">&nbsp;</span>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-4"><label for="vlastnik-telefon">telefon:</label></div>
          <div class="p-col-2">
            <input type="text" id="vlastnik-telefon" formControlName="telefon" *ngIf="form.value.souhlasVlastnika" />
            <span class="input-like" *ngIf="!form.value.souhlasVlastnika">&nbsp;</span>
          </div>
          <div class="p-col-1"><label for="vlastnik-email">e-mail:</label></div>
          <div class="p-col-5">
            <input type="text" id="vlastnik-email" formControlName="email" *ngIf="form.value.souhlasVlastnika" />
            <span class="input-like" *ngIf="!form.value.souhlasVlastnika">&nbsp;</span>
          </div>
        </div>

      </div>

      <div class="p-grid">
        <div class="p-col-4"><label for="souhlas-vlastnika"><span class="sekce">14) Souhlas vlastníka se sběrem</span>, není-li vlastníkem dodavatel</label></div>
        <div class="p-col-8"><input type="checkbox" id="souhlas-vlastnika" formControlName="souhlasVlastnika" (click)="souhlasClickHandler()" /></div>
      </div>

      <div class="erma-zadosti-foot p-grid">
        <div class="p-col-1"><label for="misto">V</label></div>
        <div class="p-col-2"><input type="text" id="misto" formControlName="misto" /></div>
        <div class="p-col-1"><label for="datum">Dne</label></div>
        <div class="p-col-2"><input type="date" id="datum" formControlName="datum" /></div>
      </div>

    </div>
  </div>

</form>
